
export default {
  name: "BookIcon",
}
